<template>
  <form novalidate @submit.prevent="handleSubmit">
    <h2 class="login__title">
      {{
        routeName === 'FirstAccessLogin'
          ? $t(`${namespace}.firstAccess.title`)
          : $t(`${namespace}.title`)
      }}
    </h2>

    <p class="form__text">
      {{
        routeName === 'FirstAccessLogin'
          ? $t(`${namespace}.firstAccess.text`)
          : $t(`${namespace}.text`)
      }}
    </p>

    <FormTextField
      v-model="form.password"
      type="password"
      :label="$t(`${namespace}.form.passwordLabel`)"
      :placeholder="$t(`${namespace}.form.passwordPlaceholder`)"
      :disabled="submitted"
      :name="$t(`${namespace}.form.passwordName`)"
      :v-validate="{
        required: true,
        isValidPassword: true,
        min: 8
      }"
    />

    <FormTextField
      v-model="form.passwordConfirm"
      type="password"
      :label="$t(`${namespace}.form.confirmPasswordLabel`)"
      :placeholder="$t(`${namespace}.form.confirmPasswordPlaceholder`)"
      :disabled="submitted"
      :name="$t(`${namespace}.form.confirmPasswordName`)"
      :v-validate="{
        required: true,
        is: form.password,
        isValidPassword: true,
        min: 8
      }"
    />

    <div class="mb-4">
      <Button
        type="submit"
        color="secondary"
        gradient
        :disabled="submitted"
        :loading="submitted"
        block
        large
      >
        {{
          routeName === 'FirstAccessLogin'
            ? $t(`${namespace}.firstAccessButtonLabel`)
            : $t(`${namespace}.resetPassword`)
        }}
      </Button>
    </div>

    <PasswordTips :password="form.password" class="mb-0" />
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import session from '@/services/modules/session'
import formValidator from 'mixins/formValidator'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'
import PasswordTips from 'components/PasswordTips'

export default {
  name: 'ResetPassword',
  mixins: [formValidator],
  components: {
    PasswordTips
  },
  computed: {
    routeName () {
      return this.$route.name
    },

    token () {
      return this.$route.params.token
    }
  },
  data () {
    return {
      namespace: 'Views.ResetPasswordPage',
      form: {
        password: null,
        passwordConfirm: null
      },
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    resetFields () {
      this.form = {
        ...this.form,
        password: null,
        passwordConfirm: null
      }
    },

    setSubmittedValue (boolean = true) {
      this.submitted = boolean
    },

    async handleSubmit () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      this.setSubmittedValue(true)

      try {
        const { password: newPassword } = this.form
        const { token } = this

        await session.resetPassword({ token, newPassword })

        const message = this.routeName === 'FirstAccessLogin'
          ? this.$t(`${this.namespace}.form.firstAccessSuccess`)
          : this.$t(`${this.namespace}.form.resetPasswordSuccess`)

        this.showAlert({ type: 'success', message })
        this.redirectToLogin()
      } catch (error) {
        const reason = error?.response?.data?.reasons && error.response.data.reasons[0]
        const message = this.routeName === 'FirstAccessLogin'
          ? this.$t(`${this.namespace}.form.firstAccessError`)
          : this.$t(`${this.namespace}.form.resetPasswordError`)

        this.showAlert({
          type: 'error',
          message: reason || message
        })

        catchError(error)
      }

      this.setSubmittedValue(false)
    }
  },
  created () {
    session.logout()
  },
  beforeMount () {
    !this.token && this.redirectToLogin()
  }
}
</script>
